<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 text-xs-center>
        <div
          style="padding-top: 40px; padding-bottom: 200px; margin-top: -280px; margin-bottom: 20px"
        >
          <span
            style="font-size: 24px; font-weight: 300; width: 100%; text-align: center; display: block;"
            >{{ texto }}</span
          >
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "SemInformacoes",
  data() {
    return {
      texto: "",
    };
  },
  mounted() {
    setTimeout(() => {
      this.texto = "Sem informações";
    }, 5000);
  },
};
</script>

<style scoped>
/*  */
</style>
